import React from 'react';
import { Box } from '@mui/material';
import styled from '@emotion/styled';

// ==========================================
// 🎥 CHANGEMENT DE VIDÉO
// Pour mettre à jour la vidéo du tutoriel, remplacez l'ID Cloudflare ci-dessous
// avec le nouveau videoId depuis votre dashboard Cloudflare Stream
// ==========================================
const CLOUDFLARE_VIDEO_EMBED = '7e6c7b055b86d5100e61288c2c34b6f3';
const CLOUDFLARE_CUSTOMER_SUBDOMAIN = 'customer-w3g4fv6ckfw8v1zh';

const VideoContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    paddingTop: '56.25%', // Aspect ratio 16:9
    width: '100%',
    maxWidth: '100%',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.10)',
}));

const StyledIframe = styled('iframe')({
    border: 'none',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
});

/**
 * Composant pour afficher une vidéo Cloudflare Stream
 * @param {string} videoId - L'ID de la vidéo Cloudflare (par défaut: CLOUDFLARE_VIDEO_EMBED)
 * @param {boolean} muted - Vidéo en sourdine au démarrage (par défaut: true)
 * @param {boolean} preload - Précharger la vidéo (par défaut: true)
 * @param {boolean} autoplay - Lecture automatique (par défaut: false)
 */
const OnboardingVideoPlayer = ({ 
    videoId = CLOUDFLARE_VIDEO_EMBED, 
    muted = true, 
    preload = true,
    autoplay = false 
}) => {
    const videoSrc = `https://${CLOUDFLARE_CUSTOMER_SUBDOMAIN}.cloudflarestream.com/${videoId}/iframe?muted=${muted}&preload=${preload}&autoplay=${autoplay}&poster=https%3A%2F%2F${CLOUDFLARE_CUSTOMER_SUBDOMAIN}.cloudflarestream.com%2F${videoId}%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600`;

    return (
        <VideoContainer>
            <StyledIframe
                src={videoSrc}
                loading="lazy"
                allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                allowFullScreen
                title="Tutoriel MOBIUSpack"
            />
        </VideoContainer>
    );
};

export default OnboardingVideoPlayer;
